import { login, me } from "@/services/auth/authService";

export const auth = {
  state: {
    id: null,
    logged: false,
    name: "",
    email: "",
    token: "",
    message: "",
    profile: {
      created_at: "",
      email: "",
      isActive: true,
      name: "",
      profile: "",
      updated_at: "",
      _id: "",
    },
    isconnected: false,
  },

  reducers: {
    setIsconnected(state: any, res: any) {
      return {
        ...state,
        isconnected: true,
        profile: res.data,
      };
    },
    setIsNotconnected(state: any, res: any) {
      return {
        ...state,
        isconnected: false,
        profile: {},
      };
    },
    UPDATE: (state: any, key: any, value: any) => {
      return {
        ...state,
        [key]: value,
      };
    },
    loginSuccess(state: any, data: any) {
      return {
        ...state,
        logged: true,
        isAdmin: data.isAdmin,
        name: data.name,
        email: data.email,
        phone: data.phone,
        token: data.token,
        message: "",
      };
    },
    loginFail(state: any, messageError: any) {
      return {
        ...state,
        id: null,
        logged: false,
        name: "",
        email: "",
        token: "",
        message: messageError,
        // message: data.response.message,
      };
    },

    logout(state: any) {
      return {
        ...state,
        id: null,
        logged: false,
        name: "",
        email: "",
        token: "",
        message: "",
      };
    },
  },

  effects: (dispatch: any) => ({
    async asyncLogin(credentials: any) {
      try {
        let resData = await login(credentials);
        dispatch.auth.loginSuccess(resData.data);
        return resData.data;
      } catch (errors: any) {
        dispatch.auth.loginFail(errors.response.data.message);
        return false;
      }
    },
    async me() {
      try {
        let resData = await me();
        dispatch.auth.setIsconnected(resData);
        return resData.data;
      } catch (errors: any) {
        dispatch.auth.setIsNotconnected();
        return false;
      }
    },
  }),
};
